import { useEffect, useState } from 'preact/hooks';

type WidgetSize = { zoom: number; width?: number; height?: number };
const defaults: WidgetSize = { zoom: 1 };
export function useWidgetSize(id: string) {
  const key = `eoweb:widget-size:${id}`;
  const [size, setSize] = useState<WidgetSize>(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '{}');
      return { zoom: Number.isFinite(saved.zoom) ? Math.max(.75, Math.min(3, saved.zoom)) : 1,
        width: Number.isFinite(saved.width) ? Math.max(240, saved.width) : undefined,
        height: Number.isFinite(saved.height) ? Math.max(140, saved.height) : undefined };
    } catch { return defaults; }
  });
  useEffect(() => { try { localStorage.setItem(key, JSON.stringify(size)); } catch {} }, [key, size]);
  return [size, setSize] as const;
}
